var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"templates"},[_c('div',{staticClass:"row"},_vm._l((_vm.templates),function(template){return _c('div',{key:template.id,staticClass:"col-lg-3 col-md-4"},[_c('single-template',{attrs:{"template":template}})],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }